import { render, staticRenderFns } from "./startegicReportCR.vue?vue&type=template&id=7904871e&scoped=true"
import script from "./startegicReportCR.vue?vue&type=script&lang=js"
export * from "./startegicReportCR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7904871e",
  null
  
)

export default component.exports